import { render, staticRenderFns } from "./SkuPropertyTypeForm.vue?vue&type=template&id=15da23af&scoped=true"
import script from "./SkuPropertyTypeForm.vue?vue&type=script&lang=js"
export * from "./SkuPropertyTypeForm.vue?vue&type=script&lang=js"
import style0 from "./SkuPropertyTypeForm.vue?vue&type=style&index=0&id=15da23af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da23af",
  null
  
)

export default component.exports